import { useEffect } from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useAuth } from "@clerk/react"
import { Loader2 } from "lucide-react"
import { requireLogin } from "@/lib/authGate"
import { RequireAuth } from "./RequireAuth"

const isPublic = (path: string) =>
  path === "/ask" || path === "/nira" || path.startsWith("/nira/") || path === "/workspaces/about"

function SignedOutOnly() {
  const { pathname } = useLocation()
  const open = !isPublic(pathname)
  useEffect(() => {
    if (open) requireLogin("simulator", pathname)
  }, [open, pathname])
  return open ? <Navigate to="/ask" replace /> : <Outlet />
}

/** Signed in: the normal authenticated flow. Signed out: only the landing and guest answer pages. */
export function GuestOrAuth() {
  const { isLoaded, isSignedIn } = useAuth()
  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      </div>
    )
  }
  return isSignedIn ? <RequireAuth /> : <SignedOutOnly />
}
